import React, { useState, useEffect } from "react";
import Logo from "../../../assets/logo.png";
import { Form, Input, Button, notification } from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LockOutlined,
  MailOutlined,
  MoonOutlined,
  SunOutlined,
} from "@ant-design/icons";
import { signInApi } from "../../../api/auth";
import { useAuth } from "../../../hooks";
import { useTheme } from "../../../context/ThemeContext";
import "./LoginForm.css";
import {
  EMAIL,
  USER,
  DISPLAYNAME,
  HASH_TOKEN,
  ACCOUNTS,
  EMAIL_SUPPPORT,
  USERID,
} from "../../../config/constants";
import Modal from "../../Modal/Modal";
import ForgotPassword from "../../ForgotPassword/ForgotPassword";
import ChangePassword from "../../ChangePassword/ChangePassword";
import RequestAccessModal from "../../RequestAccessModal/RequestAccessModal";

export function LoginForm() {
  const { login } = useAuth();
  const { themeMode, toggleTheme } = useTheme();
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get("token");
    const modal = urlSearchParams.get("modal");
    if (modal === "changePassword" && token) {
      openModalChangePassword(token);
    }
  }, []);

  const openModalChangePassword = (token) => {
    setIsVisibleModal(true);
    setModalTitle("Change Password");
    setModalContent(
      <ChangePassword tokened={token} setIsVisibleModal={setIsVisibleModal} />
    );
  };

  const [inputs, setInputs] = useState({ email: "", password: "" });

  const changeForm = (e) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  function sendEmailAction() {
    const mailto = `mailto:${EMAIL_SUPPPORT}`;
    window.open(mailto);
  }

  const singIn = async () => {
    if (loading) {
      return;
    }

    setLoading(true);

    if (!inputs.email || !inputs.password) {
      notification.error({
        message: "Please fill in all the fields",
      });
      setLoading(false);
      return;
    }

    const result = await signInApi(inputs);

    if (result.code === -1) {
      notification.error({ message: result.message });
      setLoading(false);
      return;
    }

    if (result.code === 0) {
      const { fullName, email, hashToken, accounts } = result?.data;
      const userComplete = result.data;

      localStorage.setItem(DISPLAYNAME, fullName);
      localStorage.setItem(USER, JSON.stringify(result.data));
      localStorage.setItem(EMAIL, email?.main);
      localStorage.setItem(HASH_TOKEN, hashToken);
      localStorage.setItem(ACCOUNTS, JSON.stringify(accounts));
      localStorage.setItem(USERID, userComplete._id);

      login(result.data, hashToken);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const openRequestAccessModal = () => {
    setIsVisibleModal(true);
    setModalTitle("Request Access");
    setModalContent(
      <RequestAccessModal
        defaultEmail={inputs.email}
        defaultPassword={inputs.password}
        onClose={() => setIsVisibleModal(false)}
      />
    );
  };

  const openModalForgotPassword = () => {
    setIsVisibleModal(true);
    setModalTitle("Forgot Password");
    setModalContent(
      <ForgotPassword
        setIsVisibleModal={setIsVisibleModal}
        isVisibleModal={isVisibleModal}
      />
    );
  };

  return (
    <div className="login-form-shell">
      <div className="loginForm">
        <div className="login-form__topbar">
          <Button
            type="text"
            className="login-form__theme-button"
            onClick={toggleTheme}
            aria-label={
              themeMode === "dark" ? "Switch to light theme" : "Switch to dark theme"
            }
            title={themeMode === "dark" ? "Light theme" : "Dark theme"}
          >
            {themeMode === "dark" ? <SunOutlined /> : <MoonOutlined />}
          </Button>
        </div>

        <div className="containerLogo">
          <img src={Logo} alt="Pothole Repair" className="centeredLogo" />
        </div>

        <div className="login-form__heading">
          <h2>Welcome back</h2>
          <p>Access your customer portal</p>
        </div>

        <Form className="containerControls" onFinish={singIn}>
          <div className="login-form__field">
            <label className="loginInputLabel">Email Address</label>
            <Input
              name="email"
              type="email"
              placeholder="Email Address"
              className="login-form__input"
              prefix={<MailOutlined />}
              onChange={changeForm}
              value={inputs.email}
              allowClear
              autoComplete="username"
            />
          </div>

          <div className="login-form__field">
            <label className="loginInputLabel">Password</label>
            <Input.Password
              name="password"
              placeholder="Password"
              className="login-form__input"
              prefix={<LockOutlined />}
              onChange={changeForm}
              value={inputs.password}
              autoComplete="current-password"
              iconRender={(visible) =>
                visible ? (
                  <EyeTwoTone twoToneColor="#E16726" />
                ) : (
                  <EyeInvisibleOutlined />
                )
              }
            />
          </div>

          <div className="containerLoginButton">
            <Button
              type="primary"
              className="login-form__button"
              loading={loading}
              htmlType="submit"
            >
              Login
            </Button>
          </div>

          <div className="login-form__links">
            <span
              className="buttonRecuperarContraseña"
              onClick={openModalForgotPassword}
            >
              Forgot password
            </span>
            <span style={{ color: "#ccc" }}>|</span>
            <span
              className="buttonRecuperarContraseña"
              onClick={openRequestAccessModal}
            >
              Sign up
            </span>
          </div>

          <div className="login-form__support">
            <span
              className="buttonRecuperarContraseña"
              onClick={sendEmailAction}
            >
              Contact Support
            </span>
          </div>
        </Form>
      </div>

      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
      >
        {modalContent}
      </Modal>
    </div>
  );
}
